<template>
  <div>
    <echange-form
      :propForm="form"
      @submit="submit"
      :type_echanges="type_echanges"
      :edit="true"
    />
  </div>
</template>

<script>
import URL from '@/http/client/client';
import EchangeForm from '@/views/client/components/EchangeForm.vue';

import { mapActions } from 'vuex';

import From from 'vform';
export default {
  data() {
    return {
      form: new From({
        date: this.$options.filters.formatDate(new Date(), 'DD/MM/YYYY'),
        titre: '',
        commentaire: '',
        type_echange: null,
      }),
      selectedTiers: null,
      type_echanges: [],
    };
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  components: {
    EchangeForm,
  },

  methods: {
    ...mapActions('echange', ['setCurrentEchange']),
    init() {
      this.id = this.$route.params.id;

      let promise = window.axios.all([
        window.axios.get(URL.ECHANGE + '/' + this.id, {
          params: { edit: true },
        }),
        window.axios.get(URL.GET_ECHANGE_REQUIREMENTS),
      ]);

      promise
        .then(
          window.axios.spread((resp, resp2) => {
            let data = resp.data.echange;
            this.form.date = data.date;
            this.form.titre = data.titre;
            this.form.commentaire = data.commentaire;
            this.form.type_echange = data.type_echange;

            this.type_echanges = resp2.data.type_echanges;
          })
        )
        .catch();

      return promise;
    },
    submit(form) {
      form.tiers = this.selectedTiers ? this.selectedTiers.uuid : '';
      form
        .put(URL.ECHANGE + '/' + this.id)
        .then((resp) => {
          this.showSimpleAlerte('top-end', 'success', resp.data.message);

          form.reset();
          form.clear();
          this.init()
            .then(
              window.axios.spread((resp) => {
                this.setCurrentEchange(resp.data.echange);
              })
            )
            .catch();
        })
        .catch((err) => {
          form.errors.set('message', err.response.data.message);
        })
        .finally(() => {
          this.form = form;
        });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
